export function getDriverBackgroundColor(clubId: number | null): string {
  if (!clubId) return '';

  const index = clubId - 1219;
  const colors = [
    'bg-[#000000]',
    'bg-[#6692FF]',
    'bg-[#0093CC]',
    'bg-[#229971]',
    'bg-[#E80020]',
    'bg-[#E5E7EB]',
    'bg-[#FF8000]',
    'bg-[#27F4D2]',
    'bg-[#3671C6]',
    'bg-[#64C4FF]'
  ];
  return colors[index] || '';
}

export function toMillionPrice(price: number | string | null): number {
  if (!price) return 100000000;//safety not to have free players
  if (typeof price === 'string') return parseFloat(price)*1000000;
  return price*1000000;
}

export function formatPrice(price: number): string {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
  }).format(price);
}
